import { Avatar, Icon } from 'learning-panel-components';
import styles from './leaderboardItem.module.scss';

const LeaderboardItem = (props: LeaderboardItemProps) => {
    const { profilePicture, name, rank, totalScore } = props;

    return (
        <div className={styles['leaderboard-item']} key={name}>
            <div className={styles.top}>
                <Avatar name={name} avatarSrc={profilePicture} size="1.5rem" />
                <div className={styles['user-name']}>{name}</div>
            </div>
            <div className={styles.rank}>
                <Icon name="leaderboardRank" />
                <div className={styles['rank-number']}>#{rank}</div>
            </div>
            <div className={styles.score}>
                <Icon name="devCoin" className={styles.icon} />
                <div>{totalScore.toLocaleString()}</div>
            </div>
        </div>
    );
};

export type LeaderboardItemProps = {
    name: string;
    profilePicture?: string;
    totalScore: number;
    rank: number;
};

export default LeaderboardItem;
